import React from 'react'
import { formContext } from './form-root'

export function HeadlessFormV2GlobalProvider<T extends React.ElementType>({
  useServerErrors,
  children
}: HeadlessFormV2GlobalContextValue<T>) {
  return <HeadlessFormV2GlobalContext.Provider value={{ useServerErrors }}>{children}</HeadlessFormV2GlobalContext.Provider>
}

interface HeadlessFormV2GlobalContextValue<T extends React.ElementType> {
  useServerErrors(formId: string): { path: string; message: string }[] | null
  children?: React.ReactNode
}

const HeadlessFormV2GlobalContext = React.createContext<HeadlessFormV2GlobalContextValue<React.ElementType>>({
  useServerErrors() {
    throw new Error("'HeadlessFormV2GlobalContext not found. Please wrap your site with HeadlessFormV2GlobalProvider")
  }
})

export function useServerErrors(formId: string | undefined) {
  const { useServerErrors } = React.useContext(HeadlessFormV2GlobalContext)
  const context = React.useContext(formContext)
  const serverErrors = useServerErrors(formId ?? context.id)
  return serverErrors ?? EMPTY_ARR
}

const EMPTY_ARR = []
